import * as React from 'react';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { ImportSyncDataFilterSettingsModel } from "../../../models/dataSynchronization";
import { Dropdown } from 'primereact/dropdown';
import { DropdownModel } from "../../../models/dropdownModel";
import { enumToDropdownArray } from '../../../common/functions/helperFunctions';
import { ImportedDataStatus } from '../../../common/enums';
import { SyncDataStatus } from '../../../common/enums';
import { getEnumLabel } from '../../../common/functions/helperFunctions';

interface IProps {
  onSearchClick: any,
  totalRecordsCount: number
}

interface IState {
  importDataSettings: ImportSyncDataFilterSettingsModel,
  selectedType: null,
  selectedGroup: null,
  filterText: string,
  importDataStatusDropdown: Array<DropdownModel>,
  syncDataStatusDropdown: Array<DropdownModel>,
}

export class ImportDataFilter extends React.Component<IProps, IState>  {
  constructor(props) {
    super(props);
    this.state = {
      importDataSettings: new ImportSyncDataFilterSettingsModel(),
      selectedType: null,
      selectedGroup: null,
      filterText: '',
      importDataStatusDropdown: new Array<DropdownModel>(0),
      syncDataStatusDropdown: new Array<DropdownModel>(0),
    };
  }

  componentDidMount() {
    this.initializeDropdownFilters();
  }

  initializeDropdownFilters() {
    let importDataStatusDropdown: Array<DropdownModel> = [{ label: 'Select', value: -1 }].concat(enumToDropdownArray(ImportedDataStatus, true));
    let syncDataStatusDropdown: Array<DropdownModel> = [{ label: 'Select', value: -1 }].concat(enumToDropdownArray(SyncDataStatus, true));

    this.setState({
      importDataStatusDropdown: importDataStatusDropdown,
      syncDataStatusDropdown: syncDataStatusDropdown,
    });
  }

  handleChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name;

    //TODO: add here dropdown filters for statuses

    const currentSettings: ImportSyncDataFilterSettingsModel = { ...this.state.importDataSettings };
    currentSettings[name] = value;
    const fiterText = this.generateFilterText(currentSettings);
    this.setState({
      importDataSettings: { ...currentSettings },
      filterText: fiterText
    });
  }

  generateFilterText = (settings) => {
    let result = '';

    if (settings.name) {
      result += "Brand Name <strong>'" + settings.name + "'</strong>, "
    }
    if (settings.additionalTitle) {
      result += "Title <strong>'" + settings.additionalTitle + "'</strong>, "
    }
    if (settings.importDataStatusId && settings.importDataStatusId > 0) {
      result += "Import status <strong>'" + getEnumLabel(settings.importDataStatusId, ImportedDataStatus, true) + "'</strong>, "
    }
    if (settings.syncDataStatusId && settings.syncDataStatusId > 0) {
      result += "Synchronization status <strong>'" + getEnumLabel(settings.syncDataStatusId, SyncDataStatus, true) + "'</strong>, "
    }

    return result.substr(0, result.length - 2);
  }

  handleSearchButtonClick = (settings) => {
    this.props.onSearchClick(settings);
  }

  handleClearButtonClick = () => {
    this.setState({
      importDataSettings: new ImportSyncDataFilterSettingsModel(),
      filterText: ''
    });
    this.handleSearchButtonClick(new ImportSyncDataFilterSettingsModel());
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearchButtonClick(this.state.importDataSettings)
    }
  }

  handleDropdownChange = (key, value) => {
    const currentSettings: ImportSyncDataFilterSettingsModel = { ...this.state.importDataSettings };
    currentSettings[key] = value;

    const fiterText = this.generateFilterText(currentSettings);
    this.setState({
      importDataSettings: { ...currentSettings },
      filterText: fiterText
    });
  };

  render() {
    return (
      <>
        <Toolbar style={{ marginBottom: '10px' }}>
          <div>
            <InputText
              onKeyPress={(e) => this.handleKeyPress(e)}
              style={{ marginRight: "10px", marginBottom: "5px" }}
              name="name"
              placeholder="Medicine Name"
              onChange={this.handleChange}
              value={this.state.importDataSettings && this.state.importDataSettings.name ? this.state.importDataSettings.name : ''}
            />
            <InputText
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="additionalTitle"
              style={{ marginRight: "10px", marginBottom: "5px" }}
              placeholder="Additional Title"
              onChange={this.handleChange}
              value={this.state.importDataSettings && this.state.importDataSettings.additionalTitle ? this.state.importDataSettings.additionalTitle : ''}
            />
            <Dropdown
              style={{ marginRight: "10px", marginBottom: "5px" }}
              value={this.state.importDataSettings && this.state.importDataSettings.importDataStatusId ? this.state.importDataSettings.importDataStatusId : -1}
              options={this.state.importDataStatusDropdown}
              onChange={(e) => this.handleDropdownChange('importDataStatusId', e.value)}
            />
            <Dropdown
              style={{ marginRight: "10px", marginBottom: "5px" }}
              value={this.state.importDataSettings && this.state.importDataSettings.syncDataStatusId ? this.state.importDataSettings.syncDataStatusId : -1}
              options={this.state.syncDataStatusDropdown}
              onChange={(e) => this.handleDropdownChange('syncDataStatusId', e.value)}
            />
          </div>
          <div>
            <div style={{ float: "left", paddingTop: "5px", marginBottom: "5px" }}>
              Result: <strong>{this.props.totalRecordsCount}</strong>
              {this.state.filterText ? ', ' : ''}
              <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
            </div>
            <div style={{ float: "right" }}>
              <div>
                <Button
                  className="p-button-raised"
                  icon="pi pi-filter"
                  style={{ marginRight: "10px" }}
                  label="Filter"
                  onClick={() => this.handleSearchButtonClick(this.state.importDataSettings)}
                />
                <Button
                  className="p-button-secondary p-button-raised"
                  label="Clear"
                  icon="pi pi-times"
                  onClick={() => this.handleClearButtonClick()}
                />
              </div>
            </div>
          </div>
        </Toolbar>
      </>
    )
  }
}

export default ImportDataFilter;
